import { ref, onMounted, onUnmounted } from "vue";

export function useScrollEffect() {
  const horizontalScroller = ref<HTMLElement | null>(null);
  const showBlurLeft = ref(false);
  const showBlurRight = ref(true);

  const checkScroll = () => {
    if (horizontalScroller.value) {
      showBlurLeft.value = horizontalScroller.value.scrollLeft > 0;
      showBlurRight.value =
        horizontalScroller.value.scrollLeft +
          horizontalScroller.value.clientWidth !==
        horizontalScroller.value.scrollWidth;
    }
  };

  const scrollIntoView = (el: HTMLElement): void => {
    if (horizontalScroller.value && el) {
      const elLeft = el.offsetLeft;
      const leftPadding = 15;
      const elParentRight =
        horizontalScroller.value.offsetLeft +
        horizontalScroller.value.offsetWidth;
      const elParentLeft = horizontalScroller.value.offsetLeft;
      horizontalScroller.value.scrollLeft =
        elLeft -
        elParentLeft -
        (elParentRight / 2 - el.offsetWidth / 2 - leftPadding);
    }
  };

  onMounted(() => {
    if (horizontalScroller.value) {
      horizontalScroller.value.addEventListener("scroll", checkScroll);
    }
  });

  onUnmounted(() => {
    if (horizontalScroller.value) {
      horizontalScroller.value.removeEventListener("scroll", checkScroll);
    }
  });

  return { horizontalScroller, showBlurLeft, showBlurRight, scrollIntoView };
}
